import { render } from "./CustomSidebar.vue?vue&type=template&id=254a52a4&scoped=true&lang=html"
import script from "./CustomSidebar.vue?vue&type=script&lang=js"
export * from "./CustomSidebar.vue?vue&type=script&lang=js"

import "./CustomSidebar.vue?vue&type=style&index=0&id=254a52a4&lang=css&scoped=true"

import exportComponent from "/Users/numeria/Desktop/innopearl-partner-plus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-254a52a4"]])

export default __exports__